import * as React from 'react';

import FileWord32 from './FileWord32';

export const fileWord32 = () => <FileWord32 />;

export default {
    title: 'Icon/Content/FileWord32',
    component: FileWord32,
    parameters: {
        notes: "`import FileWord32 from 'box-ui-elements/es/icon/content/FileWord32';`",
    },
};
